import React, { useState } from 'react';
import { Typography, InputAdornment, IconButton, Snackbar, Alert } from '@mui/material';
import { useDispatch } from 'react-redux';

import { CustomInput } from '../../../../components/CustomInput';
import { CustomButton } from '../../../../components/CustomButton';
import { ReactComponent as ShowPassIcon } from '../../../../assets/images/showPass.svg';
import { ReactComponent as ShowPassOffIcon } from '../../../../assets/images/showPassOff.svg';
import { WrapPage } from '../WrapPage';
import { List, ListItem } from './styled';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { password, textErrors } from '../yupFieldsValidation';
import { userConfirmRegistration } from '../../../../store/user/actions';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom';

export const RegistrationPage = () => {
  const [open, setOpen] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassSecond, setShowPassSecond] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const openAlert = () => setOpen(true);
  const redirectToUserProfile = () => history.push(ROUTES.PROFILE);

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    isValid,
    isSubmitting,
    resetForm,
    handleBlur
  } = useFormik({
    initialValues: {},
    validationSchema: yup.object({
      password1: password,
      password2: password.oneOf([yup.ref('password1'), null], textErrors.PASS_SAME)
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: () => {
      if (isSubmitting) {
        dispatch(
          userConfirmRegistration(
            {
              password1: values.password1,
              password2: values.password2,
              token: document.location.search.slice(document.location.search.indexOf('=') + 1)
            },
            resetForm,
            openAlert,
            redirectToUserProfile,
          )
        );
      }
    }
  });

  const registerInput = (name) => ({
    name: name,
    value: values[name],
    error: errors[name],
    helperText: errors[name],
    onChange: handleChange,
    onBlur: handleBlur
  });

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={1000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="success"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '250px',
            height: '100px'
          }}>
          Пароль успешно задан
        </Alert>
      </Snackbar>
      <WrapPage>
        <Typography
          variant="h2"
          sx={{
            color: 'text.primary',
            marginBottom: '30px',
            marginTop: '30px',
            fontSize: '3rem'
          }}>
          Регистрация
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ color: 'text.primary', marginBottom: '30px', fontWeight: '400' }}>
          Для успешной авторизации задайте пароль
        </Typography>
        <form onSubmit={handleSubmit}>
          <CustomInput
            {...registerInput('password1')}
            placeholder="Пароль"
            type={showPass ? 'text' : 'password'}
            sx={{ marginBottom: '16px', width: '100%' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPass(!showPass)}
                    data-testid="PasswordVisibility1"
                  >
                    {showPass ? <ShowPassOffIcon /> : <ShowPassIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <CustomInput
            {...registerInput('password2')}
            placeholder="Подтвердите пароль"
            type={showPassSecond ? 'text' : 'password'}
            sx={{ width: '100%' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassSecond(!showPassSecond)}
                    data-testid="PasswordVisibility2"
                  >
                    {showPassSecond ? <ShowPassOffIcon /> : <ShowPassIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <List>
            <ListItem>Пароль должен состоять не менее чем из 8 символов</ListItem>
            <ListItem>
              Включать цифры и буквы, по крайней мере, одна из которых должна быть в верхнем
              регистре.
            </ListItem>
            <ListItem>Может содержать символы</ListItem>
          </List>

          <CustomButton
            disabled={!isValid}
            type="submit"
            size="large"
            variant="contained"
            sx={{ marginTop: '16px' }}>
            Подтвердить
          </CustomButton>
        </form>
      </WrapPage>
    </>
  );
};
